module.exports = __webpack_public_path__ + "img/neg-entry-exit.63b3ad1e.png";